import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppRoutes from './Routes';
import { handleBranding } from './utils';
import usePersistUrlParams from './hooks/usePersistUrlParams'; // Import the hook
import useScrollToTop from './hooks/useScrollToTop';

import './assets/styles/App.css';
import './assets/styles/Bootstrap.css';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n, i18n.language]);

  useEffect(() => {
    handleBranding();
    // Branding depends on the session's event (default team/player photos,
    // colour, app icon). The first fetch runs before sign-in, when there is no
    // event yet, and every sign-in path navigates without a reload — so fetch
    // again whenever the auth state flips, or a fresh PLG login keeps showing
    // the bundled Tornea team photos until a manual refresh.
    window.addEventListener('auth-changed', handleBranding);
    return () => window.removeEventListener('auth-changed', handleBranding);
  }, []);

  return (
    <Router>
      <PersistUrlParamsWrapper /> {/* Call the URL cleanup inside Router */}
      <ScrollToTopWrapper /> {/* Every screen opens at its top — see the hook */}
      <AppRoutes />
    </Router>
  );
}

function PersistUrlParamsWrapper() {
  usePersistUrlParams(); // ✅ Now safely inside a Router
  return null; // This component does not render anything
}

function ScrollToTopWrapper() {
  useScrollToTop(); // also inside the Router: it reads the location
  return null;
}

export default App;
